/**
 * Live review counts
 * Single source of truth for review totals across every page.
 * Fetches the public review-stats endpoint and rewrites any element marked with:
 *   data-live-review-count  -> "700+" style rounded total
 *   data-live-review-total  -> exact total
 *   data-live-rating        -> average rating (e.g. 4.9)
 *   data-animate-count      -> animated counter target (reviews page hero)
 * Values typed into the theme editor stay as the fallback if the fetch fails.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://bhcxhlfmlrmplikvdfnl.supabase.co/functions/v1/review-stats';

  function apply(stats) {
    if (!stats || !stats.total_reviews) return;

    var rounded = stats.display_count || stats.total_reviews;
    var rating = stats.average_rating ? Number(stats.average_rating).toFixed(1) : null;

    document.querySelectorAll('[data-live-review-count]').forEach(function (el) {
      el.textContent = rounded + (el.getAttribute('data-suffix') || '+');
    });

    document.querySelectorAll('[data-live-review-total]').forEach(function (el) {
      el.textContent = String(stats.total_reviews);
    });

    if (rating) {
      document.querySelectorAll('[data-live-rating]').forEach(function (el) {
        el.textContent = el.getAttribute('data-suffix')
          ? rating + el.getAttribute('data-suffix')
          : rating;
      });
    }

    document.querySelectorAll('[data-animate-count][data-live-count]').forEach(function (el) {
      el.setAttribute('data-animate-count', String(rounded));
      // If the counter already finished animating to the fallback value, correct it.
      setTimeout(function () {
        el.textContent = rounded + (el.getAttribute('data-suffix') || '+');
      }, 2400);
    });

    window.dispatchEvent(new CustomEvent('reviews:stats', { detail: stats }));
  }

  function load() {
    try {
      var cached = sessionStorage.getItem('ias_review_stats');
      if (cached) apply(JSON.parse(cached));
    } catch (e) { /* ignore */ }

    fetch(ENDPOINT, { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (stats) {
        if (!stats) return;
        try { sessionStorage.setItem('ias_review_stats', JSON.stringify(stats)); } catch (e) { /* ignore */ }
        apply(stats);
      })
      .catch(function () { /* keep theme-editor fallbacks */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', load);
  } else {
    load();
  }
})();
